// extracted by css-extract-rspack-plugin
export default {"cls1":"Playlist-cls1_FOO","cls2":"Playlist-cls2_68C Playlist-cls1_FOO"};